import React, { useEffect,useState } from "react";
import "../../../../style.css";
import BootstrapTable from "react-bootstrap-table-next";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  displayCommaFormatter,
  rowStyle2,
} from "containers/gstr2a2bNewEnhancement/Utility/utility";
import { useDispatch, useSelector } from "react-redux";
import {
  setDocViewTableData,
  setSelectedMismatch,
  setSelectedRowMismatch,
} from "containers/gstr2a2bNewEnhancement/Reconciliation/action";
import ReactPaginate from "react-paginate";
import NoData from "containers/gstr2a2bNewEnhancement/Utility/NoData";
import UserComment from "../UserComment";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import CloseIcon from "@material-ui/icons/Close";
import { Typography } from "@material-ui/core";
// let tableData = [
//   { id: "1", gstin: "1234567" },
//   { id: "2", gstin: "ABCD" },
// ];

const Table = (props) => {
  const dispatch = useDispatch();
  const {
    selectedMismatch,
    docViewTableData,
    totalPageMismatch,
    selectedRowMismatch,
    pageNoMismatch
  } = useSelector((store) => store.gstr2a2bNewRecoReducer);
   const [open, setOpen] = useState(false);
  const [commentRow, setCommentRow] = useState([]);

    const userCommentsFormatter = (cell, row) => {
    return (
      <div
        style={{
          width: "100%",
          cursor: "pointer",
          textDecoration: "underline",
          color: "#4f2d7f",
        }}
        onClick={() => {
          console.log("row::", row.TXN_ID);
          setCommentRow(row);
          setOpen(true);
        }}
      >
        {"Link"}
      </div>
    );
  };
  
  const handleCloseComment = () => {
    setOpen(false);
    setCommentRow([]);
  };
  const columns = [
    {
      dataField: "ORIGINAL_MATCH_TYPE",
      text: "Original Match Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) =>
        displayNullFormatter(row, "ORIGINAL_MATCH_TYPE"),
    },
    {
      dataField: "GSTIN_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN_PURCHASE"),
    },
    {
      dataField: "GSTIN",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN"),
    },
    {
      dataField: "CTIN_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_PURCHASE"),
    },
    {
      dataField: "CTIN_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "CTIN_SALE"),
    },
    {
      dataField: "INUM_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INUM_PURCHASE"),
    },
    {
      dataField: "INUM_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "INUM_SALE"),
    },
    {
      dataField: "IDT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "IDT_PURCHASE"),
    },
    {
      dataField: "IDT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "IDT_SALE"),
    },
    {
      dataField: "POS_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "POS_PURCHASE"),
    },
    {
      dataField: "POS_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "POS_SALE"),
    },
    {
      dataField: "TXVAL_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_PURCHASE"),
    },
    {
      dataField: "TXVAL_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "TXVAL_SALE"),
    },
    {
      dataField: "IAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "IAMT_PURCHASE"),
    },
    {
      dataField: "IAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "IAMT_SALE"),
    },
    {
      dataField: "CAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CAMT_PURCHASE"),
    },
    {
      dataField: "CAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CAMT_SALE"),
    },
    {
      dataField: "SAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "SAMT_PURCHASE"),
    },
    {
      dataField: "SAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "SAMT_SALE"),
    },
    {
      dataField: "CSAMT_PURCHASE",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CSAMT_PURCHASE"),
    },
    {
      dataField: "CSAMT_SALE",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayCommaFormatter(row, "CSAMT_SALE"),
    },
    {
      dataField: "RETURN_PERIOD",
      text: "PR",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RETURN_PERIOD"),
    },
    {
      dataField: "RET_PERIOD",
      text: "GSTN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "RET_PERIOD"),
    },
    {
      dataField: "GSTR2B_PERIOD",
      text: "GSTR-2B Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTR2B_PERIOD"),
    },
    {
      dataField: "Report24",
      text: "Matched Month",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "Report24"),
    },
    {
      dataField: "ITC_AVAILABILITY",
      text: "ITC Availability as per 2B",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ITC_AVAILABILITY"),
    },
    {
      dataField: "ITC_UNAVAILABILITY_REASON",
      text: "ITC Un-availability as per 2B reason",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "3.6%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "ITC_UNAVAILABILITY_REASON"),
    },
    {
      dataField: "USER_COMMENTS",
      text: "User Comments",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "2.8%",
      },
      // formatter: (cell, row) => displayNullFormatter(row, "USER_COMMENTS"),
      formatter: userCommentsFormatter,
    },
  ];


  // function handleOnSelect(row, isSelect) {
  //   if (isSelect) {
  //     dispatch(setSelectedMismatch([...selectedMismatch, row.TXN_ID]));
  //     dispatch(setSelectedRowMismatch([...selectedRowMismatch, row]));
  //   } else {
  //     let selected = [...selectedMismatch];
  //     selected.splice(selected.indexOf(row.TXN_ID), 1);
  //     dispatch(setSelectedMismatch(selected));
  //     let value = 
  //     dispatch(
  //       setSelectedRowMismatch((selectedRow) => {
  //         let result = selectedRow.filter((x) => x !== row);
  //         return result;
  //       })
  //     );
  //   }
  // }
function handleOnSelect(row, isSelect) {
  if (isSelect) {
    dispatch(setSelectedMismatch([...selectedMismatch, row.TXN_ID]));
    dispatch(setSelectedRowMismatch([...selectedRowMismatch, row]));
  } else {
    const updatedMismatch = selectedMismatch.filter(id => id !== row.TXN_ID);
    dispatch(setSelectedMismatch(updatedMismatch));

    const updatedRows = selectedRowMismatch.filter(r => r.TXN_ID !== row.TXN_ID);
    dispatch(setSelectedRowMismatch(updatedRows));
  }
}


  function handleOnSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.TXN_ID);
    if (isSelect) {
      dispatch(setSelectedMismatch(ids));
      dispatch(setSelectedRowMismatch(rows));
    } else {
      dispatch(setSelectedMismatch([]));
      dispatch(setSelectedRowMismatch([]));
    }
  }
  const selectRow = {
    mode: "checkbox",
    selected: selectedMismatch,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    headerColumnStyle: {
      width: "37px",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "37px",
      textAlign: "center",
    },
  };

  useEffect(() => {
    console.log("selectedRowMismatch::", selectedRowMismatch);
    console.log("selectedMismatch::", selectedMismatch);
  }, [selectedMismatch, selectedRowMismatch]);

  useEffect(()=>{
    return () => {
      dispatch(setSelectedMismatch([]));
      dispatch(setDocViewTableData([]));
      dispatch(setSelectedRowMismatch([]))
    };
  },[])
  return (
    <>
      {docViewTableData?.length > 0 ? (
        <>
          <div
            id="tableDiv-scroll"
            className="light-border-gstr2a2bnew-table"
            style={{ maxHeight: "500px" }}
          >
            <div
              style={{
                display: "flex",
                width: "450%",
              }}
            >
              <div style={{ backgroundColor: "#4F2D7F", width: "4.4%" }}></div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "7.2%",
                }}
              >
                Recipient GSTIN
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "7.2%",
                }}
              >
                Supplier GSTIN
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{
                  width: "7.2%",
                }}
              >
                Document Number
              </div>

              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                Document Date
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                POS
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                Taxable Value
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                IGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                CGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                SGST
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                CESS
              </div>
              <div className="gstr2a2bnew-header-div" style={{ width: "7.2%" }}>
                Tax Period
              </div>
              <div
                className="gstr2a2bnew-header-div"
                style={{ width: "16.4%" }}
              ></div>
            </div>

            <BootstrapTable
              keyField="TXN_ID"
              data={docViewTableData}
              columns={columns}
              rowStyle={rowStyle2}
              selectRow={selectRow}
            />
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPageMismatch}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={props.handlePageClick}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
            forcePage={pageNoMismatch > 0 ? pageNoMismatch - 1 : 0}

          />
        </>
      ) : (
        <NoData />
      )}
      <Dialog
        aria-labelledby="customized-dialog-title"
        fullWidth={true}
        maxWidth="sm"
        open={open}
      >
        <MuiDialogTitle
          disableTypography
          style={{ color: "#4f2d7f", backgroundColor: "white" }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div></div>
            <Typography variant="h6">{"User Comment"}</Typography>
            <CloseIcon
              onClick={handleCloseComment}
              style={{ cursor: "pointer" }}
            />
          </div>
        </MuiDialogTitle>
        <MuiDialogContent dividers>
          <div>
            <UserComment commentRow={commentRow} handleSubmit={props.handleSubmit} handleCloseComment={handleCloseComment} />
          </div>
        </MuiDialogContent>
      </Dialog>
    </>
  );
};

export default Table;
